module.exports = __webpack_public_path__ + "img/nagasaki_oomura.2458aa30.jpg";